module.exports = __webpack_public_path__ + "static/media/Marcelo.7c13e001.png";